$.fn.loadView = function (o) {
    /// <summary>Loads a task</summary>
    /// <param name="o" type="Object">Task options</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function (i, el) {

        var me = $(el);
        if (me.isMainView()) {

            cafm.views.closeActionWindows();
        }

        cafm.views.request(me, o);
    });
    return this;
}

$.fn.isMainView = function () {
    /// <summary>Determines if the element is the main view element</summary>
    /// <returns type="Boolean">True if the element is the main view element with a class of 'mainContentPane'</returns>

    return $(this).attr('id') == cafm.views.mainViewId;
}

$.fn.isActionForm = function () {
    /// <summary>Determines if the element is an action form element</summary>
    /// <returns type="Boolean">True if the element is an action form with a class of 'actionForm'</returns>

    return $(this).attr('id') == cafm.res.consts.ElementId_ActionForm;
}

$.fn.getParentWindowElement = function () {

    return $('.k-window-content', $(this).closest('.k-window'));
}

$.fn.getParentWindow = function () {

    return $(this).getParentWindowElement().data('kendoWindow');
}

$.fn.showImp = function () {
    /// <summary>Shows an element by removing the css class 'hiddenImp'</summary>

    return $(this).removeClass(cafm.res.consts.CssClass_Hidden).removeClass(cafm.res.consts.CssClass_HiddenImportant);
}

$.fn.hideImp = function () {
    /// <summary>Hides an element using a CSS class with display:none !important</summary>

    return $(this).addClass(cafm.res.consts.CssClass_HiddenImportant);
}

$.fn.showElementInWindow = function (args) {
    /// <summary>Shows an element in a window with an option of how much spacing is required between the element and the viewport, great for images</summary>
    /// <param name="args" type="Object">Args object, space = the total space between the element and viewport edge, title = the window title</param>
    /// <returns type="$">Returns the jQuery element</param>

    var img = this;        
    img.scaleImageToViewPort(args.space);
    var wrapper = $('<div class="room-layout-image-wrapper"></div>').append(img.css('display', 'block'));    

    var win = wrapper.kendoWindow({
        draggable: false,
        resizable: false,
        modal: true,
        title: args.title,
        activate: function (e) {

            $(window).on('click.winimg touchend.winimg', function () {

                e.sender.close();
            });

            e.sender.element.on('click.winimg touchend.winimg', function () {

                return false;
            });

            $(window).resize(function () {

                img.scaleImageToViewPort(args.space);
                e.sender.center();
            });
        },
        close: function (e) {

            $(window).off('click.winimg touchend.winimg');

            setTimeout(function () {

                cafm.util.kendoDestroy(e.sender.wrapper);
                e.sender.wrapper.remove();
            }, 500)
        }
    }).data('kendoWindow');

    win.open();
    win.center();

    return this;
}

cafm.views = {
    /// <summary type="Object">CAFM Tasks container object</summary>

    mainViewId: 'mainContentPane',
    mainViewSelector: '#mainContentPane',
    renderTime: 1500,
    items: [], // values/objects to be stored and used for each view
    actionWindowConfig: {
        small: {
            height: function () {

                return 160;
            }
        },
        smallMedium: {
            height: function () {

                return 260;
            }
        },
        medium: {
            height: function () {

                return 320;
            },
            width: function () {

                return 600;
            }
        },
        mediumLarge: {
            width() {
                return 800;
            },
            height() {                       
                return screen.height >= 768 ? 520 : screen.height - 200;
            }
        },
        large: {
            height: function () {

                return cafm.util.viewPortHeight(80);
            },
            width: function () {

                return cafm.util.viewPortWidth(80);
            }
        }
    },
    request: function (tskPnl, options) {
        /// <summary>Requests a task and writes the task markup to the target panel</summary>
        /// <param name="tskPnl" type="JQuery">The task panel element</param>
        /// <param name="options" type="Object">Task options</param>

        // is main view?
        var isMv = tskPnl.isMainView();

        if (isMv) {

            cafm.util.kendoDestroy(tskPnl);
            cafm.views.loadingMain = true;
        }

        if (!options.showInWin && !options.preventLoader) {

            if (isMv) {
                if ($('#main > .clp').length) $('#main').hideLoader({ timeout: 0 });
                $('#main').showLoader({
                    forceLoader: true
                });
            }
            else if (options.loaderSelector) {
                $(options.loaderSelector).showLoader();
            }
            else {
                tskPnl.showLoader();
            }
        }

        var doRequest = function(tskPnl, options) {

            cafm.ajaxBegin = [];
            cafm.ajaxEnd = [];
            var tskUrl = options.url;
            var reqMeth = options.method ? options.method : (options.values ? 'POST' : 'GET');
            var tskData = options.values;
            cafm.web.keepAlive.updateLastServerActivity();

            // ensure the timeout
            var tout = options.timeout;
            if (!tout || tout < 1000) {

                var cs = cafm.getClientSettings();
                tout = cafm.isOffline() ? cs.ajaxTimeoutOffline : cs.ajaxTimeout;
            }

            // set values to persist from client to the server, such as current module etc
            // this is to avoid using the session server side and hitting concurrency issues over multiple browser tabs
            cafm.web.funcs.setCookie();

            $.ajax({
                url: tskUrl,
                type: reqMeth,
                contentType: 'application/json',
                data: tskData ? JSON.stringify(tskData) : null,
                processData: false,
                timeout: tout,
                beforeSend: options.beforeSend || $.noop(),
                success: function (r, m, req) {

                    try {

                        cafm.views.load(r, tskPnl, options);
                    }
                    finally {

                        var cs = cafm.getClientSettings();
                        if (cs.offlineEnabled) {

                            cafm.views.checkOnlineStatus();
                        }
                    }                    
                },
                error: function (r, m, s) {

                    if (!r.status && !cafm.isOffline()) {

                        cafm.msg.showMessageInWindow({
                            type: cafm.enums.MessageType.Error,
                            title: cafm.res.str.MessageConnectionError,
                            closeOnClick: true
                        });
                    }
                    else {

                        if (r.status != 401) {

                            tskPnl.html(r.responseText);
                            cafm.views.executeEndScripts();
                        }
                        if (r.status == 403 || r.status == 404 || r.status >= 500) {

                            cafm.router.removeCachedRouteInfo();
                        }
                        if (tskPnl.isMainView()) {

                            delete cafm.views.loadingMain;
                        }
                    }
                },
                complete(r, m, s) {
                    if (tskPnl.isMainView()) {
                        $('#main').hideLoader();
                    }
                    else if (options.loaderSelector) {
                        $(options.loaderSelector).hideLoader();
                    }
                    else {
                        tskPnl.hideLoader();
                    }
                },
                statusCode: {

                    302(r, s, m) { // treat 302 as 401, as the only time an AJAX request will redirect is when the client is not authenticated.

                        cafm.auth.notAuthenticated(true);
                    },
                    401(r, s, m) {

                        cafm.auth.notAuthenticated(true);
                    }
                }
            });
        }

        if (options.requestDelay) {
            setTimeout(function () {
                doRequest(tskPnl, options);
            }, options.requestDelay);
        }
        else {
            doRequest(tskPnl, options);
        }
        return true;
    },
    load: function (res, tskPnl, options) {
        /// <summary>Initialises the task</summary>
        /// <param name="res" type="JQuery">The task HTTP response</param>
        /// <param name="tskPnl" type="JQuery">The task panel element</param>
        /// <param name="options" type="Object">Task options</param>
                
        cafm.views.items = [];
        //tskPnl.off('content-changing').on('content-changing', function () { cafm.CAFMReactDOM.Disposable.unmountAll(tskPnl) });

        if (isMobile && tskPnl.isMainView()) {

            $("#header-details").remove();
        }

        if (tskPnl.isMainView() || tskPnl.closest('.react-container').length) {

            cafm.CAFMReactDOM.Disposable.unmountAll(tskPnl);
        }

        //tskPnl.hide().trigger('content-changing').html(res);

        tskPnl.hide().html(res);

        // if this is a main view initialise hierarchy
        if (tskPnl.isMainView()) {
            
            cafm.hi.init();
        }

        // execute scripts included in the ajax response as begin scripts
        cafm.views.executeBeginScripts();

        // if this is a main view initialise hierarchy
        if (tskPnl.isMainView()) {

            cafm.toolbar.helpers.ensureToolbarDisplay();
        }

        // on init handler for doing things before the end scripts
        if (isFunc(options.onInit)) {

            options.onInit(tskPnl, options);
        }

        var targPnl = tskPnl;

        var win;
        if (options.showInWin) {

            var winOpts = {
                draggable: false,
                resizable: false,
                modal: false,
                actions: ['Close'],
                visible: false
            };

            if (options.winOptions) {

                $.extend(winOpts, options.winOptions);
            }

            if (!isFunc(options.winOptions.close)) {

                winOpts.close = cafm.views.destroyTaskWindowOnClose;
            }

            if (options.winTarget) {

                targPnl = $(options.winTarget, tskPnl);
                tskPnl.remove();
            }

            win = targPnl.kendoWindow(winOpts).data('kendoWindow');

            if (options.winClass) {

                $(win.element).parent('.k-window').addClass('popupWindow').addClass(options.winClass);
            }

            targPnl.data('window', win);
        }

        if (options.autoViewModel) {

            options.viewModel = options.viewModel ? options.viewModel : {};
        }

        if (options.isForm) {

            $('.cTb', targPnl).setupToolbar({ container: targPnl, viewModel: options.viewModel });
        }

        if (options.viewModel) {

            var t = options.viewModelTarget ? $(options.viewModelTarget, targPnl) : targPnl;
            options.targPnl = targPnl;
            t.bindViewModel(options);
        }

        if (options.isForm) {

            targPnl.prepareForm();
        }

        targPnl.setupDotNav().moveChildren();        

        // execute scripts included in the ajax response as end scripts
        cafm.views.executeEndScripts();

        var winButtons = $('.winButtons', targPnl);
        if (winButtons.length) {
            cafm.util.positionWindowButtons({
                container: winButtons
            });
            var parentWin = targPnl.getParentWindow();
            if (parentWin) parentWin.center();
        }
        else if (win) {
            win.center();
            $(window).off('resize.task').on('resize.task', function () {
                win.center();
            });
        }

        if (isFunc(options.onLoad)) {

            options.onLoad(targPnl);
        }

        var renderFunc;
        if (!options.noRenderEffect) {

            switch (options.renderEffect) {

                case this.showEffects.Show:
                    renderFunc = 'show';
                    break;
                case this.showEffects.Slide:
                    renderFunc = 'slideDown';
                    break;
                default: // default is fade
                    renderFunc = 'fadeIn';
                    break;
            }
        }
        else
            renderFunc = 'show';

        var rTime;
        if (options.noRenderEffect) {

            rTime = 0;
        }
        else {

            rTime = options.renderTime ? options.renderTime : cafm.views.renderTime;
        }

        targPnl[renderFunc](rTime, function () {

            if (tskPnl.isMainView()) {

                delete cafm.views.loadingMain;
            }
        });

        var a = options.action;
        if (a) {

            a.set('elementId', targPnl.attr('id'));
            a.load();
            targPnl.data('action', a);
        }

        if (options.showInWin && win) {

            win.open();
        }
    },
    applyEvents: function (tskPnl) {
        /// <summary>Applies the task events</summary>
        /// <param name="tskPnl" type="JQuery">The task panel element</param>

        $('#cancelTask,[data-role="cancelTask"],[role="closePanel"]', tskPnl).bind('click', function (e) {

            cafm.views.end(tskPnl);
        });
    },
    end: function (tskPnl) {
        /// <summary>Ends the task</summary>
        /// <param name="tskPnl" type="JQuery">The task panel element</param>

        tskPnl.fadeOut(function () {

            tskPnl.remove();
        });
    },
    showEffects: {
        Fade: 'fade',
        Show: 'show',
        Slide: 'slide' 
    },
    executeBeginScripts: function () {

        if (isArray(cafm.ajaxBegin) && cafm.ajaxBegin.length) {

            $.each(cafm.ajaxBegin, function (i, scriptItem) {

                scriptItem();
            });
        }
    },
    executeEndScripts: function () {

        if (isArray(cafm.ajaxEnd) && cafm.ajaxEnd.length) {

            $.each(cafm.ajaxEnd, function (i, scriptItem) {

                scriptItem();
            }); 
        }
    },
    destroyTaskWindowOnClose: function (e) {

        setTimeout(function () {

            cafm.util.kendoDestroy(e.sender.wrapper);
            e.sender.wrapper.remove();
        }, 400);
    },
    openActionWindow: function (o) {

        var t;

        if (o.winTitle) {

            t = o.winTitle;
        }
        else if (o.winOptions) {

            t = o.winOptions.title;
        }

        if (!cafm.util.hasStringVal(t)) t = '';

        var ap;

        if (isMobile) {

            var otherAp = $('.actionPanel');
            if (otherAp.length) {

                otherAp.hide();
            }

            $('#main,#footer').hide();

            let actionFormPlc = $('<div />', {
                id: !otherAp.length ? 'actionFormPlc' : 'actionFormPlc2',
                'class': 'actionPanel mobileActionPanel'
            });

            // if not visible hide the element
            if (o.visible === false) actionFormPlc.hide(); 

            let onViewLoad = pnl => {
                if (!cafm.util.hasStringVal(t)) {

                    t = pnl.find('.actionForm[data-title]:first').data('title');
                }

                if(t) actionFormPlc.prepend($('<header class="mobileActionHeader"><h1 class="mobileActionTitle">{0}</h1></header>'.format(t)));

                if (isFunc(o.onLoad)) {
                    o.onLoad(pnl);
                }

                setTimeout(function () {
                    try { document.getSelection().removeAllRanges(); } catch (err) { }
                }, 500);
            }

            if (!isNullOrUndefined(o.content)) {

                if (isStr) {

                    actionFormPlc.html(o.content);
                }
                else if (isJQuery) {

                    actionFormPlc.append(o.content);
                }

                onViewLoad(actionFormPlc);
            }
            else {

                actionFormPlc.loadView({
                    url: o.url,
                    values: o.values,
                    viewModel: o.viewModel,
                    viewModelTarget: o.viewModelTarget,
                    initialText: cafm.res.str.TextPreparingForm,
                    noRenderEffect: true,
                    onInit: function (pnl) {

                        body.addClass('dialogue-active');

                        if (isFunc(o.onInit)) {
                            o.onInit(pnl);
                        }
                    },
                    onLoad: onViewLoad,
                    beforeSend: isDefined(o.winOptions)? o.winOptions.beforeSend:null,
                    isForm: isDefined(o.isForm) ? o.isForm : (o.url != 'LocalityLookup')
                });
            }

            actionFormPlc.appendTo(body);
        }
        else {

            ap = $('#actionPanel');

            var winOpts = {
                draggable: false,
                resizable: false,
                actions: !o.preventWinClose ? ['Close'] : [],
                modal: true,
                title: t,
                close: function (e) {

                    if (isFunc(o.onWindowClose)) {

                        o.onWindowClose(e);
                    }

                    cafm.views.removeActionWindow(e);
                }
            };
            if (o.winOptions) {
                $.extend(winOpts, o.winOptions);
            }
            if (o.closeOnOverlayClick) {

                winOpts.activate = function (e) {

                    $('.k-overlay').on('click.actionwindow', function () {
                        e.sender.close();
                    });
                };
            }

            var actionPanel = $('<div/>', {
                id: !ap.length ? 'actionPanel' : 'actionPanel2',
                'class': 'actionPanel'
            });
            var actionFormPlc = $('<div/>', {
                id: !ap.length ? 'actionFormPlc' : 'actionFormPlc2'
            });
            actionPanel.append(actionFormPlc);

            var minH = winOpts.minHeight, maxH = winOpts.maxHeight;
            if (!winOpts.resizable) {
                delete winOpts.minHeight;
                delete winOpts.maxHeight;
            }
            var win = actionPanel.kendoWindow(winOpts).data('kendoWindow');
            var winParent = $(win.element).parent('.k-window');
            winParent.addClass('actionWindow');
            if (winOpts.ensureWidth) {
                winParent.addClass('ensured-width');
            }
            if (o.winClass) {
                winParent.addClass(o.winClass);
            }

            win.center();
            if (!isDefined(o.visible) || o.visible === true) win.open();

            var onViewLoad = function (targPnl) {

                if (!isTouch) {

                    $(window).off('resize.action').on('resize.action', function () {
                        win.center();
                    });
                }

                var winButtons = $('.winButtons', targPnl);
                if (winButtons.length) {
                    cafm.util.positionWindowButtons({
                        container: winButtons
                    });
                }

                if (!cafm.util.hasStringVal(t)) {

                    t = targPnl.find('.actionForm[data-title]:first').data('title');
                    if (t) {

                        win.title(t);
                    }
                }

                targPnl.show();

                if (!(winOpts.height)) {

                    var c = win.element, sh = c[0].scrollHeight;
                    if (isInt(minH) && minH > sh) sh = minH;
                    else if (isInt(maxH) && maxH < sh) sh = maxH;
                    c.height(sh);
                }

                win.center();

                if (isFunc(o.onLoad)) {
                    o.onLoad(actionFormPlc, win);
                }
            }

            if (!isNullOrUndefined(o.content)) {

                if (isStr) {

                    actionFormPlc.html(o.content);
                }
                else if (isJQuery) {

                    actionFormPlc.append(o.content);
                }

                onViewLoad(actionFormPlc);
            }
            else {

                actionFormPlc.showMessage({
                    Title: o.initialText ? o.initialText : cafm.res.str.TextLoading,
                    LoadingMessage: true
                });

                actionFormPlc.loadView({
                    url: o.url,
                    method: !o.method ? 'POST' : o.method,
                    values: o.values,
                    isForm: isDefined(o.isForm) ? o.isForm : true,
                    viewModel: o.viewModel,
                    viewModelTarget: o.viewModelTarget,
                    preventLoader: true,
                    requestDelay: 1000,
                    onInit: o.onInit,
                    onLoad: onViewLoad,
                    beforeSend: isDefined(o.winOptions) ? o.winOptions.beforeSend : null
                });
            }
        }
    },
    closeActionWindows: function () {

        if (isMobile) {

            var map = $('.actionPanel');
            map.fadeOut(function(){

                $('#main,#footer').fadeIn();
                map.remove();
            });
        }
        else {

            var actionPanel = $('#actionPanel');
            var actionPanel2 = $('#actionPanel2');

            if (actionPanel2.length) {

                cafm.views.closeActionWindow(actionPanel2);
            }
            if (actionPanel.length) {

                cafm.views.closeActionWindow(actionPanel);
            }
        }
    },
    closeActionWindow: function (ap, cb) {

        if (isMobile) {

            if (!isJQuery(ap)) {

                let panelToClose = $(`#${cafm.res.consts.ElementId_ActionForm2}:visible`);
                if (!panelToClose.length) panelToClose = $(`#${cafm.res.consts.ElementId_ActionForm}`);
                ap = panelToClose;
            }

            if (cafm.resetSiteLogoText) {
                cafm.util.callFunction('cafm.resetSiteLogoText');
                delete cafm.resetSiteLogoText;
            }

            var tmpId = cafm.guid.newGuid();
            ap.attr('data-tmpid', tmpId);
            ap.hide(0, function () {

                cafm.util.kendoDestroy(ap);
                ap.remove();

                if (isFunc(cb)) {

                    cb();
                }
            });

            var otherAp = $('.actionPanel:not([data-tmpid="{0}"])'.format(tmpId));
            if (otherAp.length) {

                otherAp.show();
            }
            else {
                body.removeClass('dialogue-active');
                body.removeClass('scan-dialogue-active');
                $('#main,#footer').show();
                cafm.toolbar.helpers.ensureToolbarDisplay();
            }
        }
        else {

            if (!isJQuery(ap)) {
                ap = $('#actionPanel2:visible');
                if (!ap.length) ap = $('#actionPanel');
            }
            var win = ap.data('kendoWindow');
            if (win) {
                win.close();
            }
        }        
    },
    removeActionWindow: function (e) {
        
        e.sender.element.each(function (i, apItem) {

            var win = $(apItem).data('kendoWindow');
            if (win) {

                // delay the destroy on edge so the animation completes

                // CAFM-5190 cannot delay the destroy on edge - due to kendo bug
                if (cafm.browsers.isEdge()) {
                    win.destroy();
                }
                else {
                    setTimeout(function () {
                        win.destroy();
                    }, 400);
                }
            }
        });
    },
    getActionForm: function () {
        /// <summary>Gets the action form element</summary>
        /// <returns type="$">Returns the action form element</returns>

        return $('#' + cafm.res.consts.ElementId_ActionForm);
    },
    getActionForm2: function () {
        /// <summary>Gets the second action form element</summary>
        /// <returns type="$">Returns the action form element</returns>

        return $('#' + cafm.res.consts.ElementId_ActionForm2);
    },
    getActionWindowViewModel: function () {

        return cafm.views.getActionForm().getViewModel();
    },
    getActiveActionWindowViewModel: function () {

        return cafm.views.getActionForm2().getViewModel() || cafm.views.getActionForm().getViewModel();
    },
    validateActionForm: function () {

        var actionForm = cafm.views.getActionForm();
        var isValid = actionForm.validateElement();

        if (!isValid) {

            actionForm.showMessage({ Type: cafm.enums.MessageType.Error, Title: cafm.res.str.MessageInvalidInput });
        }
        else {

            actionForm.hideMessage();
        }

        return isValid;
    },
    bindActionWindowViewModel: function (vm) {

        return cafm.views.getActionForm().bindViewModel(vm);
    },
    getMainForm: function () {
        /// <summary>Gets the main form element for the app</summary>
        /// <returns type="$">Returns the main form element</returns>

        return $('#' + cafm.res.consts.ElementId_MainForm);
    },
    getMainFormWidget: function () {

        return $('#' + cafm.res.consts.ElementId_FormWidget);
    },
    getMainFormViewModel: function (childTarget) {

        var mainForm = cafm.views.getMainForm();
        var targetElement;

        if (childTarget) {

            targetElement = $(childTarget, mainForm);
        }
        else {

            targetElement = mainForm;
        }

        if (targetElement.length > 1) {

            targetElement = targetElement.first();
        }

        return targetElement.getViewModel();
    },
    bindMainFormViewModel: function (viewModel, childTarget) {

        var mainForm = cafm.views.getMainForm();
        var targetElement;

        if (childTarget) {

            targetElement = $(childTarget, mainForm);
        }
        else {

            targetElement = mainForm;
        }

        return targetElement.bindViewModel(viewModel);
    },
    openChildActionWindow: function (e) {

        var a = e.action ? e.action : e.item.data('action'),
            t = e.title ? e.title : (e.item ? $('.k-in', e.item).text() : ''),
            winOpts = {
                title: t,
                height: isNum(e.height) ? e.height : cafm.views.actionWindowConfig.medium.height(),
                beforeSend: e.beforeSend
            };
        
        if (e.winOptions) {
            $.extend(winOpts, e.winOptions);
        }

        cafm.views.openActionWindow({
            url: cafm.url.get(a),
            viewModel: e.viewModel,
            isForm: true,
            initialText: cafm.res.str.TextPreparingForm,
            winOptions: winOpts,
            onInit: e.onInit,
            onLoad: e.onLoad
        });
    },
    main: function (o) {

        cafm.views.checkNavigatorOnline();

        if (isMobile) {

            var m = $('#main');
            if (!m.is(':visible')) {

                m.show();
            }
        }

        this.mainView().loadView(o);
    },
    checkNavigatorOnline: function () {
        if (cafm.isOfflineEnabled() && !cafm.isOffline() && !navigator.onLine) {
            cafm.setOffline(true);
        }
    },
    mainView: function () {
        /// <summary>Gets the main central view for the application</summary>
        /// <returns type="$">Jquery element</returns>

        return $(this.mainViewSelector);
    },
    getActionPanelElement() {
        return $(isMobile ? "#actionFormPlc" : "#actionPanel");
    },
    setViewItem: function (key, value) {

        cafm.views.items[key] = value;
    },
    getViewItem: function (key) {

        return cafm.views.items[key];
    },
    checkOnlineStatus: function () {

        if (cafm.isOffline()) {

            cafm.views.showOfflineMessage();
        }
        else {

            cafm.views.hideOfflineMessage();
        }
    },
    isActionWindowOpen: () => {

        return $('.actionWindow:visible').length > 0;
    },
    showOfflineMessage: function(isActionMessage, targetSelector){

        var mv;
        if (targetSelector) {
            mv = $(targetSelector);
        }
        else {
            var mv = $('body > .offlineMsg');
            if ($('.mainContentPane > .offlineMsg').length) return;
            if (!mv.length) {
                if ($('body > .msgPnl').length) $('body > .msgPnl').remove();
                mv = $('<div>', { 'class': 'msgPnl' }).prependTo(body);
            }
        }

        if (!mv.find('.attemptReload').length || isActionMessage) {

            var to = !cafm.res ? 1000 : 1;
            var iam = cafm.util.isTrue(isActionMessage);
            setTimeout(function () {

                var msgStr = [iam ? cafm.res.str.MessageCafmWebOfflineAction : cafm.res.str.MessageCafmWebOffline];
                msgStr.push(' ');

                if (!iam) {

                    // get last sync time
                    var ls = cafm.cache.get(cafm.res.consts.CacheKey_LastMyJobsSync);
                    if (ls) {
                        msgStr.push(cafm.res.str.TemplateCafmWebOffline2.format(ls));
                    }
                }

                mv.showMessage({
                    type: cafm.enums.MessageType.Warning,
                    title: msgStr.join(''),
                    cssClass: 'offlineMsg',
                    link: {
                        text: cafm.res.str.LabelAttemptReload,
                        cssClass: 'attemptReload'
                    }
                });

                $('.attemptReload', mv).click(function () {
                    cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskMyJobs);
                    //TODO:Correctly navigate by fixing anchor issue after offline work. See SVN log
                    return false;
                });
            }, to);
        }
    },
    hideOfflineMessage: function () {
        
        $('.offlineMsg').hideMessage().html('');
    }
}